import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { AlmoxarifadosService } from '../../../services/almoxarifados.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { setFieldFormValue, setFormValue } from '../../../general/utils';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-almoxarifado',
  templateUrl: './almoxarifado.component.html',
  styleUrls: ['./almoxarifado.component.css']
})
export class AlmoxarifadoComponent extends ModalCadastroComponent implements OnInit {

  @ViewChild("modalCadastro", { static: true }) modalCadastro;

  constructor(private almoxarifadoService: AlmoxarifadosService) {
    super();
  }

  cadastroForm = new FormGroup({
    id: new FormControl(null),
    nome: new FormControl(null, [Validators.required]),
  })

  ngOnInit() {

  }

  editar(id: number) {
    this.id = id;
    this.carregaDados();
    this.modalCadastro.show();
  }

  cadastrar(searchParam) {
    this.id = null;
    setFieldFormValue(this.cadastroForm, 'nome', searchParam);
    this.modalCadastro.show();
  }

  carregaDados() {
    if (this.id) {
      this.alteraLoading(true);
      this.almoxarifadoService.getAlmoxarifadoById(this.id)
        .pipe(finalize(() => this.alteraLoading(false)))
        .subscribe((res) => {
          setFormValue(this.cadastroForm, res);
        })
    }
  }

  submitForm() {
    if (this.cadastroForm.valid) {
      this.alteraLoading(true);
      this.almoxarifadoService.post(this.cadastroForm.value)
        .pipe(finalize(() => this.alteraLoading(false)))
        .subscribe(res => {
          this.id = res.generatedId || null;
          this.modalCadastro.hide();
        }, (error) => {
          this.errors = error.msg.errors;
        })
    }
  }

}
